import * as React from "react";
import {} from "@blueprintjs/core";
import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import { useCommonHooks } from "../../hooks";
import { useAgentRef } from "../../hooks/applicationHooks/useAgentRef";

import { ReferentialItemDto } from "../../api";
import { nameof } from "../../utils";
import _ from "lodash";

export interface AgentSelectProps
  extends Pick<
    IFGSelectInputProps<any>,
    "requiredMark" | "visible" | "disabled" | "style" | "readonly"
  > {
  name: string;
  label?: string;
  loading?: boolean;
  exceptAgentId?: number;
  exceptAgentDossierId?: number;
}

export const AgentSelect: React.FunctionComponent<AgentSelectProps> = ({
  name,
  label,
  exceptAgentId,
  exceptAgentDossierId,
  loading = false,
  ...fgSelectInputProps
}) => {
  const { t } = useCommonHooks();
  const { agents, agentsLoading } = useAgentRef(
    exceptAgentId,
    exceptAgentDossierId
  );

  const agentsOrdered = _.orderBy(
    agents,
    ["additionalDisplayValue", "displayValue"],
    ["asc", "asc"]
  );

  return (
    <FGSelectInput
      label={label || t("Agent")}
      name={name}
      items={agentsOrdered}
      loading={agentsLoading || loading}
      renderDisplayValue={(item) =>
        `${item.additionalDisplayValue} - ${item.displayValue}`
      }
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};

export default AgentSelect;
